export const TOKEN_EXPIRATION = 900;
export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm";
export const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
